<div *ngIf="visible" class="toast-message">
    <i class="{{ icon }}"></i>
    <span [innerHTML]="message"></span>
  </div>